<template>
  <div
    :data-testid="`title-card-${title.id}`"
    class="tw-flex tw-flex-row tw-w-full tw-group"
    :class="backgroundClass"
  >
    <SfDragHandle :dragging="dragging" />

    <div class="tw-grow">
      <component :is="title.size" class="tw-font-semibold tw-m-0 tw-py-1">
        {{ title.content }}
      </component>
    </div>

    <div
      class="
        tw-min-w-8 tw-w-8 tw-flex tw-justify-center tw-items-center tw-text-base
      "
    >
      <span
        data-testid="title-card-remove"
        class="tw-invisible group-hover:tw-visible hover:tw-cursor-pointer"
        @click.stop="emitRemove"
      >
        <i
          class="
            fa fa-trash
            tw-text-sf-neutral-light-2
            hover:tw-text-sf-neutral
          "
        />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import SfDragHandle from '@app/shared/vue/components/sf-drag-handle/sf-drag-handle.vue'
import type { Title } from '@app/application/communication/types'

interface Props {
  title: Title
  dragging: boolean
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    removeTitle: []
  }>()

const emitRemove = () => {
  emit('removeTitle')
}

const backgroundClass = computed(() => ({
  'hover:tw-bg-sf-snow-dark hover:tw-rounded-lg active:tw-bg-sf-snow-dark':
    !props.dragging,
}))
</script>

<style scoped lang="scss">
[draggable='true'] {
  opacity: 0.5;
}
</style>
